import { useState } from "react";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import CancelIcon from "@mui/icons-material/Cancel";
import { Button, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import { dormitoryRequests } from "api/dormitoryApi";
import { useNotifyError } from "utils/useNotifyError";
import { currentRoomLabel, hasPendingMove, pendingRoomLabel } from "../Partials/roomLabels";

// Cancels an approved-but-not-yet-confirmed move. The resident stays in the current room; the
// display reverts to the current room after the list refreshes. ConfirmModal handles the pending
// state, error notification and refresh-only-on-success, so onConfirm needs no try/catch.
//
// As with confirmation, the move is resolved from a fresh read rather than the list row: once a
// cancelled campaign has already released its transfers there is nothing left to cancel, and asking
// the backend again would act on a move that no longer exists. The read leaves the source room
// exactly as it is - only the confirmed action below changes anything.
const CancelMoveDialog = ({ record }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const refresh = useRefresh();
  const [accommodation, setAccommodation] = useState(null);

  const handleOpen = async () => {
    if (!record?.id) {
      notify("Липсва идентификатор на настаняването.", { type: "error" });
      return false;
    }

    try {
      const { data } = await dataProvider.customRequest(
        dormitoryRequests.getAccommodationById(record.id),
        null,
        "GET",
      );

      if (!hasPendingMove(data)) {
        notify("Няма предстоящо преместване за отказване.", { type: "warning" });
        refresh();
        return false;
      }

      setAccommodation(data);
    } catch (err) {
      notifyError(err);
      return false;
    }

    return true;
  };

  const handleConfirm = async () => {
    await dataProvider.customRequest(dormitoryRequests.cancelAccommodationMove(record.id), null, "PUT");
    notify("Преместването е отказано", { type: "info" });
    refresh();
  };

  const move = accommodation || record;

  return (
    <ConfirmModal
      onOpen={handleOpen}
      onConfirm={handleConfirm}
      titleContent="Отказване на преместване"
      saveTitle="Откажи преместване"
      closeTitle="Затвори"
      resetProps={() => setAccommodation(null)}
      message={`Отказвате предстоящото преместване в стая ${pendingRoomLabel(move)}? Студентът остава в стая ${currentRoomLabel(move)}.`}
      triggerButton={<Button startIcon={<CancelIcon />} label="Откажи преместване" />}
    />
  );
};

export default CancelMoveDialog;
